import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["data-testid"]
const _hoisted_2 = ["aria-hidden", "data-testid"]
const _hoisted_3 = ["data-testid"]
const _hoisted_4 = ["data-testid"]

import { computed } from 'vue'

import type {
  PriorityPaymentRow,
  PrioritySlaDto,
  PrioritySlaThresholds
} from '@/Network/Types/Responses/PriorityPaymentsResponses'

import {
  PRIORITY_SLA_TEXT_CLASS,
  formatSlaCountdown,
  formatSlaDueText,
  formatSlaShortDuration,
  formatSlaStamp,
  isPendingSlaState,
  resolveLiveSla
} from '../slaFormat'

/**
 * Countdown grande do M3 com o prazo absoluto embaixo. Sem `aria-live`: um
 * leitor de tela anunciando a cada segundo torna a fila inutilizável. O leitor
 * lê o texto por extenso (`sr-only`, em minutos); o número visual (mm:ss) fica
 * `aria-hidden` — `aria-label` num `<span>` sem role não é lido de forma confiável.
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'PrioritySlaCountdown',
  props: {
    sla: {},
    row: {},
    nowMs: { default: null },
    thresholds: { default: null },
    size: { default: 'md' },
    testId: { default: 'priority-sla-countdown' }
  },
  setup(__props: any) {

const props = __props;



const live = computed(() =>
  props.sla ? resolveLiveSla(props.sla, props.nowMs, props.thresholds) : null
)

const value = computed(() => {
  const sla = props.sla
  const current = live.value
  if (!sla || !current) return '—'
  if (current.state === 'DONE') {
    return sla.completedAt ? formatSlaStamp(sla.completedAt, props.nowMs) : '—'
  }
  if (current.remainingSeconds === null) return '—'
  return formatSlaCountdown(current.remainingSeconds)
})

const srText = computed(() => {
  const current = live.value
  if (!current || current.remainingSeconds === null || !isPendingSlaState(current.state)) {
    return undefined
  }
  const duration = formatSlaShortDuration(current.remainingSeconds)
  return current.state === 'OVERDUE' ? `atrasado há ${duration}` : `faltam ${duration}`
})

const toneClass = computed(() =>
  live.value ? PRIORITY_SLA_TEXT_CLASS[live.value.state] : 'text-neutral50'
)

const due = computed(() =>
  props.sla && live.value ? formatSlaDueText(props.sla, live.value, props.row, props.nowMs) : null
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "relative flex min-w-0 flex-col",
    "data-testid": _ctx.testId
  }, [
    _createElementVNode("span", {
      class: _normalizeClass(["font-mono font-bold leading-none tabular-nums", [_ctx.size === 'lg' ? 'text-2xl' : 'text-lg', toneClass.value]]),
      "aria-hidden": srText.value ? 'true' : undefined,
      "data-testid": `${_ctx.testId}-value`
    }, _toDisplayString(value.value), 11, _hoisted_2),
    (srText.value)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: "sr-only",
          "data-testid": `${_ctx.testId}-sr`
        }, _toDisplayString(srText.value), 9, _hoisted_3))
      : _createCommentVNode("", true),
    (due.value)
      ? (_openBlock(), _createElementBlock("span", {
          key: 1,
          class: "mt-1 text-[11px] text-neutral50",
          "data-testid": `${_ctx.testId}-due`
        }, _toDisplayString(due.value), 9, _hoisted_4))
      : _createCommentVNode("", true)
  ], 8, _hoisted_1))
}
}

})